import styled from "styled-components";
import { colors } from "ui-components";

const RiskWarningDialogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${colors.white}
`;

const RiskWarningDialogHeader = styled.div`
  width: 100%;
  padding: 2rem;
  color: ${colors.white};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background-color: ${colors.darkBlue};
`;

const RiskWarningDialogContent = styled.div`
  padding: 2rem;
  text-align: center;
`;

const RiskWarningDialogDescription = styled.div`
  font-size: 12px;
`;

const RiskWarningDialogText = styled.div`
  margin: 4rem 0;
  color: ${colors.maroon};
  font-size: 20px;
  font-weight: bold;
`;

const RiskWarningDialogButtons = styled.div`
  margin-bottom: 1rem;

  button:not(:last-of-type) {
    margin-right: 1.5rem;
  }
`;

export {
  RiskWarningDialogWrapper,
  RiskWarningDialogHeader,
  RiskWarningDialogContent,
  RiskWarningDialogDescription,
  RiskWarningDialogText,
  RiskWarningDialogButtons
};



// WEBPACK FOOTER //
// ./src/workerhome/components/Dialogs/RiskWarningDialog/styled.js